{
  "language": {
    "label": "语言",
    "description": "界面语言。新建的工作区将沿用此语言生成报告。",
    "english": "English",
    "french": "Français",
    "chinese": "中文"
  },
  "settings": {
    "title": "设置",
    "appearance": "外观",
    "darkMode": "深色模式",
    "darkModeOnDescription": "当前使用深色主题",
    "darkModeOffDescription": "当前使用浅色主题",
    "dangerZone": "危险操作区",
    "clearAll": "清除全部内容",
    "clearAllDescription": "永久删除所有项目、文件、报告、日志和模型",
    "purge": "清除"
  },
  "modelSet": {
    "title": "模型集",
    "label": "模型集",
    "choose": "选择",
    "loading": "正在加载模型集…",
    "noneAvailable": "目前没有可用的模型集。",
    "appliesAll": "此设置适用于整个部署及所有工作区。更改将在下一次模型调用时生效；已在运行的工作不受影响。",
    "errorTimeout": "请求耗时过长。请重试。",
    "errorNetwork": "无法连接到服务器。请检查网络连接后重试。",
    "errorGeneric": "出了点问题。请重试。"
  },
  "workspace": {
    "createTitle": "创建工作区",
    "outputLanguage": "报告语言",
    "outputLanguageHint": "此工作区生成的报告将使用该语言撰写。创建后不可更改。",
    "outputLanguageLockedHint": "报告语言在创建后已锁定。",
    "create": "创建",
    "cancel": "取消"
  },
  "actions": {
    "ok": "确定",
    "cancel": "取消",
    "save": "保存",
    "delete": "删除",
    "edit": "编辑",
    "close": "关闭",
    "confirm": "确认",
    "submit": "提交",
    "next": "下一步",
    "previous": "上一步",
    "back": "返回",
    "continue": "继续",
    "retry": "重试",
    "refresh": "刷新",
    "copy": "复制",
    "copied": "已复制",
    "download": "下载",
    "upload": "上传",
    "remove": "移除",
    "add": "添加",
    "rename": "重命名",
    "search": "搜索",
    "filter": "筛选",
    "clear": "清除",
    "loading": "加载中…",
    "approve": "批准",
    "reject": "拒绝",
    "open": "打开",
    "view": "查看",
    "more": "更多",
    "less": "收起",
    "yes": "是",
    "no": "否"
  },
  "status": {
    "loading": "加载中…",
    "saving": "保存中…",
    "saved": "已保存",
    "ready": "就绪",
    "error": "错误",
    "pending": "等待中",
    "complete": "已完成",
    "failed": "失败",
    "draft": "草稿",
    "approved": "已批准",
    "rejected": "已拒绝"
  },
  "time": {
    "justNow": "刚刚",
    "minutesAgo_one": "{{count}} 分钟前",
    "minutesAgo_other": "{{count}} 分钟前",
    "hoursAgo_one": "{{count}} 小时前",
    "hoursAgo_other": "{{count}} 小时前",
    "daysAgo_one": "{{count}} 天前",
    "daysAgo_other": "{{count}} 天前"
  },
  "dialog": {
    "confirmDeleteTitle": "确认删除",
    "unsavedChangesTitle": "未保存的更改",
    "unsavedChangesBody": "您有未保存的更改。是否放弃？",
    "discard": "放弃"
  },
  "empty": {
    "noResults": "无结果。",
    "noData": "暂无数据。"
  },
  "image": {
    "loading": "图像加载中…",
    "imageNotFound": "未找到图像",
    "loadFailed": "图像加载失败",
    "missingArtifactRef": "缺少素材引用",
    "imageUnavailable": "图像不可用",
    "artifactLabel": "素材：{{id}}",
    "embeddedAlt": "嵌入图像",
    "couldNotLoad": "⚠ 图像无法加载",
    "couldNotLoadAria": "图像无法加载",
    "couldNotLoadAriaWithAlt": "图像无法加载 — {{alt}}"
  },
  "citation": {
    "loadingData": "正在加载引用数据…",
    "loadTimedOut": "无法加载引用数据。请重试。",
    "notAvailable": "引用内容不可用。",
    "referencedContent": "引用内容",
    "source": "来源：",
    "referencedImageAlt": "引用图像",
    "download": "下载",
    "filename": "文件名：",
    "documentRole": "文档角色：",
    "dataType": "数据类型：",
    "contentDescription": "内容描述：",
    "metadataUnavailable": "此来源暂无可用元数据。",
    "sourceClassClient": "客户机构知识库",
    "sourceClassBennie": "Kyronyx 专家知识库"
  },
  "callouts": {
    "dataGap": "数据缺口 — {{topic}}",
    "dataGapAria": "数据缺口：{{topic}}",
    "validationAction": "验证操作 — {{topic}}",
    "validationActionAria": "验证操作：{{topic}}"
  },
  "findings": {
    "noCitationsParseable": "无法从此发现的证据中读取任何引用。",
    "citationLabel": "引用 [{{id}}]",
    "rootCause": "根本原因",
    "classification": "分类",
    "crossDimensionRefs": "跨维度引用",
    "observation": "观察",
    "expectedStandard": "预期标准",
    "impact": "影响",
    "recommendation": "建议",
    "missingPlaceholder": "—",
    "themeLabel": "主题：{{value}}",
    "typeLabel": "类型：{{value}}",
    "primaryLabel": "主要：{{value}}",
    "attributionLabel": "归属：{{value}}",
    "tagLabel": "标签：{{value}}",
    "supportingSymptoms_one": "{{count}} 个佐证表征（{{first}}）",
    "supportingSymptoms_other": "{{count}} 个佐证表征（{{first}} … {{last}}）",
    "loadingSymptoms": "正在加载表征详情…",
    "symptomMeta": "§{{section}} · 类型 {{severity}}",
    "symptomMetaLegacy": "§{{section}} · 类型 {{severity}} · {{legacyId}}",
    "symptomMetaCite": "§{{section}} · 类型 {{severity}}",
    "symptomMetaLegacyCite": "§{{section}} · 类型 {{severity}} · {{legacyId}}"
  },
  "clearAll": {
    "idleTitle": "清除全部内容",
    "idleDescription": "此操作将<strong>永久删除</strong>所有项目、上传的文件、生成的报告、运行日志以及所有已注册的模型。",
    "alertHeading": "此操作无法撤销！",
    "alertBody": "以下内容将被永久删除：",
    "bulletWorkspaces": "所有项目，包括已归档项目和 Reggie 项目",
    "bulletFiles": "所有上传的文件与提取的图像",
    "bulletReports": "所有运行、发现项与生成的报告",
    "bulletLogs": "所有模型调用日志",
    "bulletModels": "整个模型注册表：每个模型及其详细信息、版本、访问授权与问题日志",
    "keptNote": "用户账户、登录访问权限、提示词、设置和共享知识服务不会改变。模型访问授权会随模型一并删除。",
    "confirmPrompt": "请按所示原样输入 {{phrase}} 以确认。",
    "confirmLabel": "确认短语",
    "cancel": "取消",
    "goButton": "清除全部内容",
    "purgingTitle": "正在清除所有数据…",
    "connecting": "正在连接…",
    "purgingWorkspaces": "正在移除 {{count}} 个项目…",
    "removingProjects": "正在等待 {{count}} 个项目完成删除…",
    "removingData": "正在移除文件、日志和注册表数据…",
    "successTitle": "已全部清除",
    "successBody": "所有项目、文件、报告、日志和模型均已删除。正在跳转…",
    "readBackNow": "当前：剩余 {{projects}} 个项目和 {{models}} 个模型。",
    "readBackNotEmpty": "清除已报告完成，但仍列出 {{projects}} 个项目和 {{models}} 个模型。请再次执行。",
    "readBackFailed": "清除已完成，但读取当前状态失败。请刷新页面查看剩余内容。",
    "deletedItemsHeading": "已删除项目：",
    "goToWorkspaces": "前往工作区",
    "errorTitle": "错误",
    "tryAgain": "重试",
    "back": "返回",
    "unknownError": "发生未知错误",
    "failedToClear": "清除失败：{{status}} {{statusText}}",
    "refusedNotAdmin": "只有管理员可以清除全部内容。未删除任何内容。",
    "refusedConfirmation": "确认短语不匹配。未删除任何内容。",
    "noResponseStream": "无响应流",
    "partialFailure": "部分数据未能完全移除，其余数据已删除。请再次执行清除以完成。",
    "partialFailureRemaining": "有 {{count}} 个项目未能在限定时间内完全删除，因此模型注册表保持不变。其余内容均已删除。请再次执行清除以完成。",
    "streamEndedEarly": "服务器在确认清除完成之前停止了响应，部分数据可能仍然存在。请再次执行清除以检查。",
    "connectionLost": "连接已中断。正在检查清除是否已完成……",
    "connectionLostUnconfirmed": "连接已中断，无法确认清除是否已完成。请刷新此页面查看，如仍有项目或模型请再次执行。",
    "readBackUnavailable": "无法读取当前状态，因此不清楚还剩下什么。请刷新此页面，如有需要请再次执行清除。"
  },
  "serviceTypeGrants": {
    "title": "{{name}} 的部署级权限",
    "body": "此设置决定该人员在整个部署范围内可从事哪些类型的工作，与其在本模型上可修改的内容相互独立。",
    "currentHeading": "已获资格",
    "empty": "尚未为该人员单独启用任何内容。",
    "groupNote": "权限也可能来自目录组。目录组权限在您的目录中管理，此处不予列出。",
    "grantHeading": "启用其他类型的工作",
    "pickLabel": "工作类型",
    "neededHint": "此处需要",
    "grant": "启用",
    "revoke": "移除",
    "close": "关闭",
    "failedGeneric": "该更改未能保存，未作任何改动。"
  },
  "modelInventory": {
    "title": "模型库",
    "description": "浏览和管理您的模型目录。选择类别以查看模型。",
    "modelsCount_one": "{{count}} 个模型",
    "modelsCount_other": "{{count}} 个模型",
    "backToInventory": "← 返回模型库",
    "modelsInCategory_one": "此类别下共 {{count}} 个模型",
    "modelsInCategory_other": "此类别下共 {{count}} 个模型",
    "searchPlaceholder": "搜索模型…",
    "noModels": "未找到模型。",
    "fallbackTitle": "模型",
    "statusActive": "启用",
    "statusDraft": "草稿",
    "statusDeprecated": "已弃用",
    "versionUpdated": "v{{version}} • 更新于 {{date}}",
    "ariaCollapse": "收起",
    "ariaExpand": "展开",
    "ownerLabel": "负责人：{{value}}",
    "frameworkLabel": "框架：{{value}}",
    "categoryLabel": "类别：{{value}}",
    "dataLabel": "数据：{{value}}"
  },
  "appAuth": {
    "title": "需要访问权限",
    "body": "此环境受密码保护。请输入访问密码以继续。",
    "passwordLabel": "密码",
    "passwordAria": "访问密码",
    "noPasswordHint": "如果您没有密码，请联系项目负责人。",
    "submit": "进入",
    "submitting": "正在验证…",
    "incorrectPassword": "密码不正确。",
    "apiUnreachable": "无法连接 API。请检查网络后重试。",
    "sessionExpired": "会话已过期或密码被拒绝。请重新输入。",
    "identityUnavailable": {
      "title": "Bennie 暂时不可用",
      "body": "我们无法确认您的会话。请稍后重试。",
      "retry": "重试"
    },
    "ssoBootstrap": {
      "signingBackIn": "正在为您重新登录…",
      "stuckTitle": "登录耗时超出预期",
      "stuckBody": "无法恢复您的会话，请重新登录。",
      "tryAgain": "重试"
    }
  },
  "modelActions": {
    "edit": "编辑名称与类型",
    "archive": "归档",
    "alreadyArchived": "已归档",
    "editTitle": "编辑名称与类型",
    "editSubtitle": "您可以修改模型的名称和类型。",
    "nameLabel": "模型名称",
    "typeLabel": "模型类型",
    "typeHelp": "请从该模型提供的类型中选择。已保存的值即使不再提供也仍可使用。",
    "typeMenuUnavailable": "类型列表暂时不可用，目前无法修改类型。名称仍可编辑。",
    "fixedTitle": "业务线路径和已应用的标签无法编辑。",
    "fixedBody": "它们在注册时已确定。",
    "concurrencyTitle": "若他人先一步修改了该模型，您的保存将被拒绝。",
    "concurrencyBody": "系统会向您展示他人的版本并请您重新确认。",
    "cancel": "取消",
    "save": "保存更改",
    "saving": "正在保存…",
    "archiveTitle": "确认归档该模型？",
    "archiveSubtitle": "归档后无法撤销。",
    "archiveOneWayTitle": "此操作无法撤销。",
    "archiveOneWayBody": "{{name}} 将移入已归档列表，对所有人保持可见，任何人（包括管理员）都无法再修改。",
    "archiveBeneathTitle": "其下层内容的变化。",
    "archiveBeneathBody": "不能再在该模型下创建新项目。现有项目会被标记为已锁定，测试场转为只读。已生成的内容仍可查看和下载。",
    "archiveRunningTitle": "已在运行的任务不会停止。",
    "archiveRunningBody": "归档只改变该模型的状态，它不会取消已开始的报告生成、文档入库或上传——进行中的任务会继续运行，并在一个届时已转为只读的模型中完成。",
    "confirmLabel": "请输入模型名称以确认",
    "archiveGo": "永久归档",
    "archiving": "正在归档…",
    "errorGeneric": "该更改未能保存。请稍后重试。",
    "errorTimeout": "该更改耗时过长已被终止，无法确认是否已保存。请重新打开该模型查看当前状态后再试。"
  },
  "modelHome": {
    "titleUnknown": "模型",
    "loading": "正在加载模型",
    "errorNotFound": "找不到此模型。它可能已被删除，或者链接不正确。",
    "errorLoad": "当前无法加载此模型。请稍后重试。",
    "statusActive": "启用",
    "statusArchived": "已归档",
    "fieldModelId": "模型 ID",
    "fieldModelType": "模型类型",
    "fieldScopePath": "范围",
    "fieldProductCategory": "产品类别",
    "filterAll": "全部 {{count}}",
    "filterType": "{{type}} {{count}}",
    "projectsFilterLabel": "按防线筛选项目",
    "pagerProjectsAll_one": "显示第 {{from}}–{{to}} 个，共 {{count}} 个项目",
    "pagerProjectsAll_other": "显示第 {{from}}–{{to}} 个，共 {{count}} 个项目",
    "projectsEmpty": "此模型下尚未注册任何项目。",
    "projectsLoading": "正在加载项目",
    "projectsLoadFailed": "当前无法加载项目。请稍后重试。",
    "projectsSearchPlaceholder": "搜索项目",
    "projectsNoMatch": "没有与搜索匹配的项目。",
    "projectArchiveTitle": "归档此项目？",
    "projectArchiveBody": "{{name}} 将移至已归档列表，任何人都无法再修改。它仍然可见，也可以打开。不会删除任何项目。",
    "projectArchiveConfirmLabel": "输入项目名称以确认",
    "projectArchiveFailed": "无法归档此项目。请重试。",
    "projectsArchivedEmpty": "没有已归档的项目。",
    "lockedByModel": "已锁定 — 模型已归档",
    "archivedDirectly": "已归档",
    "parkRunning": "正在将导出的文件添加到新项目…",
    "parkFailedTitle": "文件未被添加",
    "parkFailed": "无法将导出的文件添加到新项目。",
    "tabOverview": "概览",
    "tabProjects": "项目",
    "tabTestGround": "测试场",
    "tabToolbox": "工具箱",
    "pagerProjects_one": "显示第 {{from}}–{{to}} 个，共 {{count}} 个{{type}}项目",
    "pagerProjects_other": "显示第 {{from}}–{{to}} 个，共 {{count}} 个{{type}}项目",
    "sectionEmpty": "此模型尚未开始任何{{type}}工作。",
    "serviceTypeUnset": "无服务类型",
    "tabAccess": "访问权限",
    "lockArchivedOn": "归档于 {{date}}。",
    "lockPill": "只读",
    "projectsLockTitle": "这些项目已锁定，您仍可继续查阅。",
    "projectsLockBody": "您可以打开报告、查阅问题日志、下载导出件，并继续与项目对话。",
    "projectsLockPill": "只读 · 可对话",
    "createDeniedForTypeTitle": "您暂时无法在该模型上开展{{type}}工作。",
    "stillWorking": "仍在处理中，可能需要一点时间。",
    "retry": "重试",
    "recheckFailed": "暂时无法重新核对该模型的状态。当前显示的是服务器最后一次确认的记录。",
    "recheckRetry": "重新核对"
  },
  "modelList": {
    "title": "模型",
    "subtitle": "已注册 {{count}} 个",
    "empty": "尚未注册任何模型。",
    "loading": "正在加载模型",
    "errorLoad": "当前无法加载模型。请稍后重试。",
    "statusActive": "启用",
    "statusArchived": "已归档",
    "searchPlaceholder": "搜索模型",
    "noMatch": "没有匹配的模型。",
    "clearSearch": "清除搜索",
    "stillWorking": "仍在处理…",
    "retry": "重试",
    "register": "注册模型",
    "registerFirst": "注册第一个模型",
    "perPage": "每页",
    "tabActive": "启用 {{count}}",
    "tabArchived": "已归档 {{count}}",
    "prev": "上一页",
    "next": "下一页"
  },
  "modelAccess": {
    "lockTitle": "已归档模型的访问权限已冻结。",
    "lockBody": "谁拥有何种权限的记录将作为审计轨迹的一部分保持可见。其中任何内容（包括所有权）均不可更改。",
    "lockPill": "只读",
    "standingHeading": "您的权限状况",
    "standingOwner": "您是该模型的所有者。",
    "standingCollaborator": "您是该模型的协作者。",
    "standingNone": "您在该模型上没有任何权限。",
    "standingOtherRole": "您在该模型上拥有某个访问角色。",
    "standingAdminOverride": "管理员覆盖权限",
    "subjectAdminBadge": "管理员",
    "standingMayWrite": "在产品提供修改入口的地方，您可以修改该模型。",
    "standingNothingToPress": "访问权限由所有者管理。",
    "identityPending": "正在确认您当前登录的账户。",
    "ownerHeading": "所有者",
    "ownerHint": "每个模型只有一位所有者，由其决定还有谁可以修改该模型。",
    "ownerIsYou": "该模型归您所有。",
    "ownerNoAllowances": "所有者通过其角色拥有全部权限。",
    "collaboratorsHeading": "协作者",
    "recordHeading": "记录",
    "registeredBy": "由{{who}}注册。",
    "registeredByOn": "由{{who}}于{{date}}注册。",
    "registrarNotOwner": "这是注册该模型的人员，不一定是当前的所有者。",
    "archivedBy": "由{{who}}归档。",
    "archivedByOn": "由{{who}}于{{date}}归档。",
    "accountIdLabel": "账户 ID",
    "you": "您",
    "noDefaultGrant": "所有人都可以查看该模型及其下的项目。只有所有者和已获授权的人员可以进行修改。",
    "retry": "重试",
    "loadFailedTitle": "无法加载访问权限名单",
    "ownerMissing": "该模型没有登记在册的所有者。管理员可以指定一位。",
    "ownerSince": "自 {{date}} 起为所有者 · 由 {{by}} 授予",
    "collaboratorsHint": "你所在组织的每个人都可以查看该模型及其下的所有内容（包括测试工作区），并且每个人都可以使用工具箱。协作者可以修改为其勾选的服务类型下的工作；勾选“协作者”后，他们可以修改测试工作区。",
    "collaboratorsNone": "尚未授予其他任何人在该模型上的修改权限。",
    "colPerson": "人员",
    "colCanChange": "可修改",
    "colAddedBy": "添加者",
    "transferOpen": "转移所有权…",
    "addOpen": "添加协作者",
    "editOpen": "编辑",
    "removeOpen": "移除",
    "transferTitle": "转移所有权",
    "transferBody": "新的所有者将接管您在此处能做的一切，而您将不再能够进行这些操作。",
    "transferNewOwnerLabel": "新所有者",
    "transferKeepsNothing": "您在该模型上将不保留任何权限。您仍可以像其他人一样查看它，但将无法再修改它，也无法决定谁可以修改。",
    "transferSubmit": "转移所有权",
    "subjectIdHelper": "任何拥有 Bennie 访问权限的人员，无论是否为管理员。您也可以粘贴目录对象 ID。",
    "subjectSearchPlaceholder": "按姓名或电子邮件搜索",
    "principalSearchIdle": "输入姓名或电子邮件即可查找人员。",
    "principalSearchTooShort": "请继续输入——搜索至少需要三个字符。",
    "principalSearching": "正在搜索贵组织的目录…",
    "principalSearchMatches": "请从列表中选择正确的人员。",
    "principalSearchTruncated": "仅显示最匹配的结果——如果没有看到目标人员，请缩小搜索范围。",
    "principalSearchNoMatch": "贵组织中没有与之匹配的人员。请核对拼写，或粘贴其目录对象 ID。",
    "principalSearchUnavailable": "无法访问目录，因此未能进行搜索。请稍后重试——这并不表示没有匹配的人员。",
    "principalResolving": "正在查找该人员…",
    "principalNotFound": "贵组织中没有使用该 ID 的人员。请先核对后再继续——尚未做出任何更改。",
    "principalUnavailable": "无法访问目录，因此未能核对该 ID。请稍后重试——尚未做出任何更改。",
    "transferConfirmHint": "这是将拥有该模型的人员。请确认无误——此操作无法撤销。",
    "addConfirmHint": "这是将被添加到该模型的人员。",
    "addTitle": "添加协作者",
    "addSubjectLabel": "人员",
    "addSubmit": "添加协作者",
    "editTitle": "编辑授权",
    "editSubmit": "保存授权",
    "allowancesHeading": "其可修改的范围",
    "allowancesHint": "勾选此人可以在该模型上修改的工作类型。勾选“协作者”后可修改测试工作区。",
    "allowancesNoneNotice": "将添加这些人员，但不授予修改权限。您可以稍后再授予。",
    "allowancesUnrestricted": "不受服务类型限制",
    "allowancesNothingYet": "暂无",
    "entitlementShortfall": "已在此授予，但在整个部署范围内尚未启用{{types}}——需由管理员单独启用后才会生效。",
    "entitlementUnknown": "暂时无法查询该人员在部署范围内的访问权限。",
    "entitlementManage": "立即启用",
    "allowancesOther": "其他",
    "allowanceCollaborator": "协作者",
    "removeTitle": "要移除此人吗？",
    "removeBody": "他们将失去在该模型上可修改的一切。他们仍可以像其他人一样查看该模型。",
    "removeSubmit": "移除",
    "cancel": "取消",
    "working": "处理中…"
  },
  "modelRegister": {
    "title": "注册模型",
    "subtitle": "先选择该模型是什么，再为它命名。仅限管理员。",
    "step1Title": "选择模型",
    "step1Hint": "与新建项目使用的菜单相同",
    "step2Title": "继续",
    "step2Hint": "打开对话框以完成注册",
    "step3Title": "为模型命名",
    "step3Hint": "命名，并核对所选路径",
    "step4Title": "模型主页",
    "step4Hint": "系统会自动跳转",
    "pickerHeading": "选择这个模型是什么",
    "pickerHint": "与新建项目使用的菜单相同。请一直选择到最后一层。",
    "adminOnly": "注册模型属于管理员操作。您可以在此浏览菜单，但只有管理员才能完成注册。",
    "leave": "离开",
    "dialogTitle": "注册模型",
    "dialogSubtitle": "为其命名并核对所选路径。",
    "sectionIdentity": "1 · 标识",
    "nameLabel": "模型名称",
    "namePlaceholder": "一个能区分该模型的名称",
    "nameHelper": "这里唯一需要您输入的内容。请取一个能把该模型与同类型的其他模型区分开来的名称。",
    "summaryStreamPath": "流路径",
    "summaryAppliedTo": "适用于",
    "summaryAppliedToNone": "未作细化——涵盖整个流。",
    "permanent": "此设置永久生效。该模型下的每个项目、测试场工作区和工具箱作业都会继承此路径。",
    "sectionCanonicals": "3 · 模型规范信息",
    "canonicalsHint": "可选。先填写您已知的内容，模型注册后仍可随时添加或修改。",
    "canonicalsUnavailableAbsent": "目前无法显示规范字段。请先注册模型，然后在模型页面中添加，并告知管理员这些字段不可用。",
    "canonicalsUnavailableUnreachable": "目前无法显示规范字段。请先注册模型，几分钟后在模型页面中添加。",
    "canonicalsUnavailableGeneric": "目前无法显示规范字段。请先注册模型，然后在模型页面中添加。",
    "canonicalsLoading": "正在加载规范字段",
    "cancel": "取消",
    "submit": "注册模型",
    "submitting": "正在注册…",
    "stillWorking": "仍在处理中，可能需要一点时间。",
    "retry": "重试",
    "errName": "请先为模型命名，然后再注册。",
    "errNotPermitted": "注册模型属于管理员操作，当前账户不是管理员。",
    "errScope": "为该模型选择的菜单路径未被接受。请返回上一步重新选择。",
    "errUnavailable": "服务菜单当前无响应，暂时无法注册该模型。请稍后重试。",
    "errTimeout": "注册耗时过长已被终止，因此无法确认模型是否已创建。请先打开模型登记册核对，再决定是否重新注册。",
    "errGeneric": "无法注册该模型。请重试。",
    "readBackFailed": "该模型已完成注册。我们暂时无法将其打开——请重试，或从模型登记册中打开。请勿重复注册。",
    "readBackRetry": "重新尝试打开"
  },
  "modelTestGround": {
    "hint": "一个隔离的场所，可在其中针对您自己的数据编排并运行模型逻辑。",
    "newWorkspace": "新建测试工作区",
    "inheritedScope": "继承的范围",
    "from": "来源",
    "onModel": "模型：<strong>{{model}}</strong>",
    "playground": "此处的流水线可以运行、导出到项目并被引用，但不属于模型的规范记录。",
    "searchPlaceholder": "搜索测试工作区…",
    "count_one": "{{count}} 个测试工作区",
    "count_other": "{{count}} 个测试工作区",
    "perPage": "每页",
    "pagerShowing_one": "显示第 {{from}}–{{to}} 个，共 {{count}} 个测试工作区",
    "pagerShowing_other": "显示第 {{from}}–{{to}} 个，共 {{count}} 个测试工作区",
    "loading": "正在加载测试工作区",
    "stillWorking": "仍在处理…",
    "errorLoad": "当前无法加载测试工作区。请稍后重试。",
    "empty": "该模型下还没有测试工作区。",
    "noMatch": "没有与您的搜索相匹配的测试工作区。",
    "lockTitle": "已归档模型的测试场仍可查看，但不会运行。",
    "lockBody": "以往的测试工作区、它们的配置以及每一次运行结果都仍然开放。新建工作区和编辑功能已关闭。",
    "lockPill": "只读",
    "writeDenied": "您无权对该模型进行修改。",
    "createScopeRejected": "Test Ground 无法使用该模型的范围。范围在模型上设置。",
    "lastActive": "最近活动 {{date}}",
    "readinessSteps_one": "此范围有 {{count}} 个现成步骤可用",
    "readinessSteps_other": "此范围有 {{count}} 个现成步骤可用",
    "readinessNone": "此范围没有现成的步骤。自定义节点始终可用。",
    "readinessUnavailable": "无法检查此范围的现成步骤。"
  },
  "dashboard": {
    "title": "仪表板",
    "subtitle": "投资组合视图，每个模型一行。",
    "loading": "正在加载投资组合视图",
    "stillWorking": "仍在处理…",
    "retry": "重试",
    "errorTitle": "无法加载投资组合视图",
    "errorBody": "请求未能完成。这通常是暂时的。",
    "errorOneMessage": "如果问题持续出现，请联系支持团队。",
    "emptyTitle": "暂无可呈现的内容",
    "emptyBody": "在注册模型并在其下开展工作后，投资组合视图便会自动填充。",
    "emptyOnlyOnSuccess": "没有任何内容加载失败；投资组合目前就是空的。",
    "periodScope": "时间段适用于所显示的模型和项目，不适用于验证完成情况或未解决问题的数字。",
    "refreshedScope": "“已刷新”指节省时间这一数字，最多每小时重新计算一次。其他数字在每次加载时重新读取。",
    "refreshed": "更新于 {{when}}",
    "refreshedUnknown": "无法获知更新时间",
    "period": {
      "label": "时段",
      "p7d": "7 天",
      "p30d": "30 天",
      "p90d": "90 天",
      "p1y": "1 年",
      "custom": "自定义"
    },
    "countsBy": {
      "label": "统计依据",
      "activity": "活动时间",
      "created": "创建时间"
    },
    "showArchived": "显示已归档",
    "warmingTitle": "正在准备投资组合视图",
    "warmingBody": "通常不到一分钟，页面会自行填充。",
    "warmingStuckTitle": "等待较久，仍在准备中",
    "warmingStuckBody": "投资组合数据尚未到达。您可以继续等待，或再次请求。",
    "staleTitle": "这些数据比应有的更旧——它们来自 {{when}}",
    "staleBody": "上次刷新未完成，因此这些数据可能已过期。",
    "refreshNow": "立即刷新",
    "partialTitle": "本页面的部分内容无法读取",
    "partialBody": "以下数字仅涵盖已成功读取的部分。可能造成误导的计数已被隐去。",
    "kpi": {
      "models": "已注册模型",
      "modelsSub": "其下共 {{projects}} 个项目",
      "modelsSubNoProjects": "项目数量暂不可用",
      "modelsTooltip": "符合所选时段的模型。",
      "approved": "已批准的报告",
      "validated": "已验证",
      "validatedSub": "本时段内已完成",
      "validatedWithheld": "暂不显示。该数字按项目统计模型，而项目列表无法读取。",
      "validatedTooltip": "统计至少有一个验证项目达到终态的模型。",
      "openIssues": "未关闭问题",
      "openIssuesSub": "T1 {{t1}} · T2 {{t2}} · T3 {{t3}} · T4 {{t4}}",
      "openIssuesWithheld": "暂不显示。只能读取部分问题数据——不完整的计数会让未解决问题看起来比实际更少。",
      "openIssuesTooltip": "已上报至模型问题日志且仍处于未关闭状态的问题，统计范围为视图中的模型。",
      "timeSaved": "节省的时间",
      "timeSavedSub": "≈ {{weeks}} 个全职人周 · {{n}} 个项目",
      "timeSavedSubWeeksOnly": "≈ {{weeks}} 个全职人周",
      "timeSavedNoData": "尚无已测量的项目",
      "timeSavedWithheld": "暂不显示。无法读取测量数据。",
      "approvedSub": "{{n}} 个没有报告",
      "approvedWithheld": "暂不显示。无法读取报告台账。",
      "approvedTooltip": "在当前视图的模型中，统计拥有已审批报告版本的模型数量。"
    },
    "coverage": {
      "title": "覆盖情况",
      "hint": "每个模型一行，每道防线一列。点击某一行即可打开该模型。",
      "search": "搜索名称、标识、类型、业务条线或注册人…",
      "stream": "业务条线",
      "allStreams": "全部业务条线",
      "colModel": "模型",
      "col_development": "开发",
      "col_validation": "验证",
      "col_auditing": "审计",
      "colLastActivity": "最近活动",
      "neverOpened": "从未打开",
      "clearFilters": "清除",
      "showing_one": "显示第 {{from}}–{{to}} 个，共 {{count}} 个模型",
      "showing_other": "显示第 {{from}}–{{to}} 个，共 {{count}} 个模型",
      "perPage": "每页",
      "cellComplete": "已完成",
      "cellInProgress": "进行中",
      "cellNone": "无",
      "tier": "风险等级",
      "allTiers": "全部风险等级",
      "colTier": "等级",
      "tierNotSet": "未设置",
      "colApproval": "审批",
      "approvalApproved": "已审批",
      "approvalPending": "待审批",
      "approvalNone": "无报告",
      "cellStale": "较早",
      "colCoverage": "开发 · 验证 · 审计",
      "segment": "{{line}}：{{state}}",
      "noMatchTitle": "没有符合这些筛选条件的模型",
      "noMatchBody": "请尝试其他搜索词、业务条线或风险等级。",
      "noPeriodTitle": "此时间段内没有模型",
      "noPeriodBody": "所选时段内没有已注册模型有活动。请在上方选择更长的时间段以重新显示它们。",
      "colCreated": "创建时间",
      "clearFiltersAction": "清除筛选",
      "showingNone": "显示 0 个，共 0 个模型",
      "legendStaleLabel": "已完成，早于所选时段",
      "prevPage": "上一页",
      "nextPage": "下一页"
    },
    "validation": {
      "title": "验证时效",
      "hint": "没有到期日，因此不会标记任何逾期。",
      "chartWithheld": "由于无法读取项目列表，无法显示验证时效。",
      "chartOmitted": "未按时效分组：{{n}} 个模型的验证没有完成日期。",
      "barMonths": "{{n}} 个月",
      "summaryValidated": "<b>{{n}}</b> 个已验证",
      "summaryNever": "<b>{{n}}</b> 个从未验证",
      "bucket0": "0–4 个月",
      "bucket1": "4–8 个月",
      "bucket2": "8–12 个月",
      "bucket3": "超过 12 个月",
      "bucketNever": "从未验证",
      "never": "从未",
      "footer": "{{n}} 个模型 · 最久 {{months}} 个月",
      "emptyTitle": "暂无验证记录",
      "emptyBody": "已完成验证的模型会显示在这里，按完成以来的时间排序。不会标记任何逾期。",
      "swipeHint": "滑动查看更多分组",
      "scrollMore": "滚动查看另外 {{n}} 个",
      "allShown": "已全部显示"
    },
    "issues": {
      "title": "按模型划分的未关闭问题",
      "hint": "已上报至各模型问题日志且仍未关闭的问题。",
      "stream": "业务条线",
      "allStreams": "全部业务条线",
      "search": "搜索模型",
      "unavailable": "已上报问题的数量无法读取。",
      "reading": "正在读取已上报问题的数量…",
      "tier": "T{{n}} · {{name}}",
      "groupModels_one": "{{count}} 个模型",
      "groupModels_other": "{{count}} 个模型",
      "summary": "{{streams}} 个业务条线中的 {{n}} 个模型 · {{total}} 个未解决问题",
      "emptyTitle": "没有未解决的问题",
      "emptyBody": "发现项被上报到模型的问题日志后会显示在这里，并在未解决期间保留。",
      "footnote": "仅统计已上报的问题。仅存在于项目自身日志中的问题不计入。",
      "scrollFor": "滚动查看另外 {{count}} 项",
      "allShown": "已全部显示",
      "more": "还有 {{count}} 项"
    },
    "hygiene": {
      "title": "注册表卫生",
      "hint": "整个活跃注册表，而非所选时间段。复查某一行即可查看其模型。",
      "noReport": "没有开发报告的模型",
      "noReportSub": "尚未为其上传任何内容。",
      "pending": "等待审批的报告",
      "pendingSub": "已上传但未批准，因此没有现行报告。",
      "canonicals": "从未确认的规范信息",
      "canonicalsSub": "由报告解析提出，此后未经确认。",
      "noProject": "没有项目的模型",
      "noProjectSub": "已注册且从未打开。",
      "review": "复查",
      "colModel": "模型",
      "colOwner": "注册人",
      "colRegistered": "注册时间",
      "notListed": "未列出：没有映射 ID 的模型，以及没有模型的项目。",
      "hide": "收起"
    },
    "completed": {
      "title": "已完成的报告",
      "hint": "达到终态的项目，按其标记完成的月份计数。",
      "withheld": "此图表依据每个模型下的项目绘制，而项目列表无法读取。",
      "omitted": "未计入：{{n}} 个已完成项目没有完成日期。",
      "barTooltip": "{{month}} — 完成 {{n}} 个",
      "emptyTitle": "暂无已完成的报告",
      "emptyBody": "项目在被标记为完成的那个月计入此处，此时项目锁定，报告不再变化。首个项目计入后将显示月度柱状图。",
      "yearHeading": "年份",
      "olderYearsBelow_one": "下方还有 {{count}} 个更早的年份",
      "olderYearsBelow_other": "下方还有 {{count}} 个更早的年份",
      "toDate": "至今",
      "allYears": "全部年份",
      "completedSince": "自 {{year}} 年起已完成",
      "bestYear": "最佳年份：{{year}} · {{n}}",
      "completedIn": "<b>{{year}}</b> 年已完成",
      "completedInSoFar": "<b>{{year}}</b> 年已完成，截至目前（{{from}}–{{to}}）",
      "deltaFirst": "有记录的第一年",
      "deltaSame": "与 {{year}} 年持平",
      "deltaSameMonths": "与 {{year}} 年同期持平",
      "deltaMore": "▲ 比 {{year}} 年多 {{n}} 个",
      "deltaMoreMonths": "▲ 比 {{year}} 年同期多 {{n}} 个",
      "deltaFewer": "▼ 比 {{year}} 年少 {{n}} 个",
      "deltaFewerMonths": "▼ 比 {{year}} 年同期少 {{n}} 个",
      "deltaPct": "({{pct}}%)",
      "avgPerMonth": "平均每月 {{avg}} 个",
      "peakNone": "暂无完成",
      "peakMany": "峰值 {{peak}} 个，出现在 {{n}} 个月",
      "peakFew": "峰值 {{months}} · {{peak}}",
      "averageTag": "平均",
      "chartNote": "所有年份使用同一刻度，因此各年份的柱高可以直接比较。虚线月份不在所覆盖的日期范围内。"
    },
    "review": {
      "search": "搜索模型、标识或注册人…",
      "registrarUnnamed": "未显示姓名",
      "registrarNone": "未记录注册人"
    },
    "more": "另外 {{n}} 个"
  },
  "modelCanonicalFields": {
    "description": "描述",
    "business_unit": "业务单元",
    "risk_tier": "风险等级",
    "lifecycle_stage": "生命周期阶段",
    "built_or_bought": "自建或采购",
    "regulatory_framework": "监管框架"
  },
  "modelOverview": {
    "mdrTitle": "模型开发报告",
    "mdrHint": "已批准的版本是每次报告运行所读取的版本。所有人都可以查看历史记录并下载任何版本；批准需要相应权限。",
    "mdrLoading": "正在加载报告历史记录",
    "mdrStillWorking": "仍在处理…",
    "mdrErrorLoad": "当前无法加载报告历史记录。请稍后重试。",
    "retry": "重试",
    "mdrEmpty": "此模型尚未上传任何开发报告。",
    "mdrAllWithdrawn": "该模型开发报告的所有版本均已撤回，因此该模型没有当前文档。历史记录见下方。",
    "mdrCurrentApproved": "这是已批准的版本——注册表视为当前版本的那一个。",
    "mdrNoneApproved": "没有任何版本获得批准，因此该模型没有当前报告。此处显示的是最新的未撤回版本。",
    "mdrUnapprovedInheritance": "没有任何版本获得批准。本模型下工作区的计划生成会将最新的待审批版本作为未批准的草稿参考使用；若没有，则在没有报告的情况下运行。",
    "mdrHistoryHeading": "版本历史（{{count}}）",
    "mdrHistoryNote": "所有版本都会保留在列表中。",
    "parse": "解析规范项",
    "parsing": "正在解析…",
    "parseCancel": "停止",
    "parseNotReadable": "已撤回的版本无法读取。",
    "parseFailed": "无法读取该报告。",
    "parseStopped": "已停止读取。未提出任何建议，也未保存任何内容。",
    "parseDone": "读取完成。下方的建议已开放供审阅 — 在你保存之前不会保存任何内容。",
    "mdrColFile": "文件",
    "mdrColStatus": "状态",
    "mdrColUploaded": "上传时间",
    "mdrColActions": "操作",
    "statusApproved": "已批准",
    "statusExempted": "已豁免",
    "exempt": "豁免",
    "unexempt": "取消豁免",
    "exemptFailed": "豁免未完成，我们无法确认是否已记录。请刷新确认后再重试。",
    "statusDraft": "待批准",
    "statusSuperseded": "已被取代",
    "statusWithdrawn": "已撤回",
    "statusUnknown": "状态不可用",
    "download": "下载",
    "approve": "批准",
    "approving": "正在批准…",
    "approveAlready": "此版本已获批准。",
    "approveNotPromotable": "此版本无法批准。",
    "approveFailed": "批准未能完成，无法确认该版本是否已获批准。请刷新查看后再重试。",
    "upload": "上传新版本",
    "uploading": "正在上传…",
    "uploadInFlightNote": "此文件不在下方列表中，要等上传完成后才会出现在那里。",
    "uploadFailed": "上传未能完成，无法确认新版本是否已记录。请刷新查看后再重新上传。",
    "mdrApprovalNote": "每个版本最初都处于待批准状态。同一时间只能有一个版本处于已批准状态。",
    "mdrDownloadNote": "仅供下载。",
    "canonTitle": "模型规范信息",
    "canonHint": "所有者声明的、关于该模型为真的内容。每次报告运行都会按声明原样读入。",
    "canonErrorLoad": "目前无法读取规范信息。请稍后重试。",
    "canonLoading": "正在读取规范信息",
    "canonStillWorking": "仍在读取…",
    "canonEmpty": "尚无人对该模型作出任何声明。",
    "canonUpdatedBy": "最后由 {{actor}} 更新于 {{date}}。",
    "canonUpdatedUnknownActor": "最后更新于 {{date}}。未记录修改者。",
    "canonOwnerLabel": "模型负责人",
    "canonOwnerNone": "该模型尚未记录负责人。",
    "canonOwnerUnavailable": "目前无法显示负责人。",
    "canonUnreviewedBadge": "已提取 — 待确认",
    "canonEdit": "编辑",
    "canonEditing": "编辑中…",
    "canonEditNotice": "在您保存之前不会写入任何内容。保存时将记录您修改的值，并确认您保持不变的值。",
    "canonSave": "保存更改",
    "canonSaving": "保存中…",
    "canonCancel": "取消",
    "canonEditFootnote": "保存会更新该信息块中的所有字段。",
    "canonNoClear": "值可以修改，但不能删除。",
    "canonNoClearBlock": "已有值的规范字段无法清空 — 只能更改，不能撤回。请为 {{fields}} 重新填写值，或点击“取消”以保持原样。",
    "canonSaveFailedTitle": "未保存任何内容。",
    "canonSavePartialTitle": "该区块部分已保存：{{saved}} 个字段已保存，{{failed}} 个未保存。",
    "canonSavedFields": "已保存：{{fields}}。",
    "canonFieldFailed": "{{field}} — {{reason}}",
    "canonReloadFailed": "您的更改已提交，但无法重新读取该区块，因此当前显示的内容可能与注册表现在保存的内容不一致。请重新加载页面后再进行编辑。",
    "issuesTitle": "问题日志",
    "issuesHint": "该模型下所有进行中项目的全部发现。发现的状态在此处修改。",
    "issuesEmpty": "该模型尚无任何问题记录。待其验证与审计项目运行后，相关发现将显示在这里。",
    "issuesLoading": "正在加载问题日志",
    "issuesStillWorking": "仍在加载问题日志……",
    "issuesErrorLoad": "问题日志加载失败，请重试。",
    "issuesSaveFailed": "该更改未能保存，请重试。",
    "issuesColIssue": "问题",
    "issuesColService": "服务",
    "issuesColSeverity": "严重程度",
    "issuesColTitle": "标题",
    "issuesColTheme": "主题",
    "issuesColProject": "项目",
    "issuesColAssignee": "负责人",
    "issuesColStatus": "状态",
    "issuesColLastAction": "最近操作",
    "issuesServiceValidation": "验证",
    "issuesServiceAuditing": "审计",
    "issuesServiceDevelopment": "开发",
    "issuesServiceUnknown": "未知",
    "issuesStatusActive": "进行中",
    "issuesStatusRemediating": "整改中",
    "issuesStatusResolved": "已解决",
    "issuesStatusUnknown": "未知",
    "issuesNoLongerDetected": "已不再检出",
    "issuesUnassigned": "未分配",
    "issuesAssigneeLoading": "正在加载可分配该模型的人员。",
    "issuesAssigneeUnavailable": "无法读取可分配该模型的人员名单，因此无法更改负责人。",
    "issuesOpenDetail": "打开“{{title}}”",
    "issuesDetailDescription": "说明",
    "issuesSourceUnknown": "来源记录不可用",
    "issuesSourceUnversioned": "未编号的来源",
    "issuesSourceReport": "来自报告 V{{version}}",
    "issuesSourceReportUnknown": "未记录报告版本号",
    "issuesSourceRun": "运行 {{id}}",
    "issuesSourceItem": "项目 {{id}}",
    "issuesOpenInProject": "在项目中打开",
    "issuesReasonRequired": "请填写状态变更的原因。",
    "issuesReasonLabel": "原因",
    "issuesStatusConfirm": "保存",
    "issuesCancel": "取消",
    "issuesActionEscalated": "已上报",
    "issuesActionStatusChanged": "状态已改为{{status}}",
    "issuesActionAssigneeChanged": "负责人已更改",
    "issuesActionStamp": "{{date}} · {{who}}",
    "startTitle": "开始处理该模型",
    "startHint": "三个快捷操作。您的授权决定您可以按下其中哪些。",
    "lineDevelopment": "开发",
    "lineValidation": "验证",
    "lineAuditing": "审计",
    "lodDevelopment": "第一道防线",
    "lodValidation": "第二道防线",
    "lodAuditing": "第三道防线",
    "lockTitle": "该模型已归档——此处内容仍可查看，但其自身信息不能再更改。",
    "lockBody": "报告、规范字段、问题日志、Test Ground 运行和 Toolbox 任务均可继续查看，其下的项目仍可查看并进行对话。",
    "approveConfirmTitle": "批准此版本？",
    "approveConfirmBody": "批准后，该模型的每份报告都会将此版本视为当前文档。其他人的工作依赖于它。您以后可以批准其他版本。",
    "approveConfirmGo": "批准版本",
    "withdraw": "撤回",
    "withdrawing": "正在撤回…",
    "withdrawAlready": "已撤回。此操作无法撤销。",
    "withdrawNotWithdrawable": "此版本无法撤回。",
    "withdrawFailed": "撤回未能完成，无法确认该版本是否已撤回。请刷新查看后再重试。",
    "withdrawConfirmTitle": "撤回此版本？",
    "withdrawTerminalBody": "撤回会将某个版本停用，但不会删除它——文件仍保留在列表中，仍可下载。它无法再次成为当前版本：已撤回的版本不能获批，也不能取消撤回。请改为上传新版本。",
    "withdrawLeavesNoCurrentTitle": "这是当前已批准的报告，撤回后该模型将没有当前报告。",
    "withdrawLeavesNoCurrentBody": "撤回已批准的版本会使该模型没有当前文档，此模型上的每次报告运行都会将其读作「未声明任何内容」。如果这不是您的本意，请先批准其他版本或上传新版本。",
    "withdrawReasonLabel": "原因",
    "withdrawReasonPlaceholder": "例如：上传到了错误的模型",
    "withdrawReasonHelper": "将连同您的姓名和时间戳记录在该版本上。",
    "withdrawConfirmGo": "撤回版本",
    "canonVocabLoading": "正在加载这些字段的可选值…",
    "canonVocabErrorAbsent": "本部署尚未发布这些字段的可选值列表，因此无法编辑规范字段。重试无法解决此问题 — 请联系支持人员。",
    "canonVocabErrorUnreachable": "暂时无法加载这些字段的可选值列表，因此无法编辑规范字段。请稍后重试。",
    "canonVocabErrorGeneric": "无法读取这些字段的可选值列表，因此无法编辑规范字段。请重试 — 如果问题持续出现，请联系支持人员。",
    "canonVocabUnset": "未声明",
    "canonVocabOffValue": "{{value}} — 不在当前列表中",
    "canonVocabRetiredValue": "{{label}} — 已不再提供",
    "canonVocabOffHelp": "此值来自模型文档，并完全按照文档中的措辞保留。可保持不变，或从列表中选择一个值。",
    "canonVocabRetiredHelp": "此值已不再用于新的填写。在有人选择其他值之前，它将保持不变。",
    "canonVocabDocumentWording": "模型文档中写道：“{{wording}}”。该表述不在列表值中，请自行填写此字段。",
    "issuesSearch": "搜索问题、标题、主题、项目或人员…",
    "issuesFilterNoTheme": "无主题",
    "issuesFilterUnnamed": "未显示姓名",
    "evidenceTitle": "证明材料",
    "evidenceLoading": "正在加载证明材料",
    "evidenceEmpty": "暂无附件。",
    "evidenceErrorLoad": "无法加载附件。",
    "evidenceAdd": "添加附件",
    "evidenceDownload": "下载",
    "evidenceRemovePending": "移除",
    "evidencePendingHint": "未保存",
    "evidenceWithdraw": "撤回",
    "evidenceUndoWithdraw": "保留",
    "evidenceWithdrawStage": "标记为撤回",
    "evidenceWithdrawReasonLabel": "撤回原因是什么？",
    "evidenceMeta": "由 {{who}} 于 {{when}} 添加",
    "evidenceWithdrawnStamp": "由 {{who}} 于 {{when}} 撤回：{{reason}}"
  },
  "serviceMenu": {
    "unavailableTitle": "无法加载服务领域列表",
    "unavailableBody": "这通常是暂时的，请稍后重试。",
    "stillWorking": "仍在处理…",
    "emptyTitle": "暂无可用的服务领域",
    "emptyBody": "没有可供选择的内容。如果您原本应看到选项，请联系管理员。"
  },
  "projectWsModel": {
    "report": {
      "title": "模型开发报告",
      "hint": "从本项目所属的模型加载。",
      "slotLabel": "已存档报告",
      "slotHelp": "该报告在模型上维护，因此其下的每个项目读取的都是同一份文档。",
      "noModelTitle": "此项目未指明所属模型",
      "noModelBody": "项目从其所属的模型读取开发报告。此项目没有记录所属模型，因此无法加载报告。",
      "noModelGap": "从某个模型的“项目”标签页创建项目时，系统会记录该模型。",
      "errorLoad": "当前无法加载报告历史记录。这并不表示该模型没有报告。",
      "retry": "重试",
      "loading": "正在加载模型开发报告",
      "stillWorking": "仍在处理…",
      "emptyTitle": "此模型尚无报告",
      "emptyBody": "尚未为 {{model}} 上传任何开发报告。一旦在该模型上上传并批准报告，此处便会显示。",
      "emptyTitleAllWithdrawn": "此模型没有当前报告",
      "emptyBodyAllWithdrawn": "{{model}} 的所有开发报告版本均已撤回，因此没有可显示的当前报告。一旦在该模型上上传并批准新报告，此处便会显示。",
      "goToModelReport": "打开模型的报告",
      "emptyNoPicker": "报告在模型上上传，而不是在项目上。",
      "metaNoDate": "日期不可用",
      "metaApproved": "已批准 · {{date}} · {{model}}",
      "metaLatestUnapproved": "最新版本 · {{status}} · {{date}} · {{model}}",
      "metaPrevious": "上一版本 · {{status}} · {{date}} · {{model}}",
      "versionGroupAria": "选择要显示的报告版本",
      "versionCurrent": "当前版本",
      "versionPrevious": "上一版本",
      "autoAddedReference": "已添加为参考资料",
      "download": "下载",
      "unapprovedNotice": "此版本尚未在模型上获得批准。之所以显示，是因为它是该模型目前持有的版本。",
      "reportBelongsToModel": "此文档属于该模型。修改在模型上进行，并会应用到其下的所有项目。"
    }
  },
  "table": {
    "showing": "显示 {{shown}} / {{total}}",
    "clearFilters": "清除筛选",
    "noMatches": "没有符合搜索或筛选条件的行。"
  },
  "chart": {
    "invalidSpec": "无法显示此图表，因为其数据无效。",
    "loadFailed": "无法加载图表。"
  }
}
